import React, { lazy } from 'react';
export function BonusesSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    title: 'BONUS 1',
    subtitle: 'Cómo crear tu Pyme de pisos epoxi',
    desc: 'Formalización, estructura y visión de negocio.',
    image: 'https://cdn.magicpatterns.com/uploads/bMgSJtBUaCDiPVMLaauA1b/WhatsApp_Image_2026-02-15_at_9.36.06_PM.jpg'
  }, {
    id: 2,
    title: 'BONUS 2',
    subtitle: 'Sistema para conseguir clientes todas las semanas',
    desc: 'Estrategia práctica para generar consultas constantes.',
    image: 'https://cdn.magicpatterns.com/uploads/ws7c3pQkT9k5eDvMN71qgp/WhatsApp_Image_2026-02-15_at_9.36.07_PM.jpg'
  }, {
    id: 3,
    title: 'BONUS 3',
    subtitle: 'Mentalidad y posicionamiento de aplicador premium',
    desc: 'Para dejar de competir por precio y cobrar mejor.',
    image: 'https://cdn.magicpatterns.com/uploads/sWzeDwHKMFB8YBS8eHykHR/WhatsApp_Image_2026-02-15_at_9.36.07_PM_(1).jpg'
  }];
  return <section className="py-16 px-4 bg-[#0a0a0a]" aria-label="Bonos incluidos" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-31">
            3 bonos incluidos para que arranques a facturar
          </h2>
          <p className="text-xl text-gray-400 font-medium max-w-2xl mx-auto" data-id="element-32">
            No alcanza con saber aplicar.{' '}
            <span className="font-bold text-amber-400" data-id="element-33">
              También hay que saber conseguir clientes y cobrar bien.
            </span>
          </p>
        </div>

        <div className="grid gap-12 md:gap-16" data-id="element-34">
          {bonuses.map(bonus => <div key={bonus.id} className="flex flex-col md:flex-row items-center gap-8 bg-[#141414] rounded-2xl p-6 md:p-8 shadow-lg border border-amber-900/30" data-id="element-35">
              <div className="w-full md:w-1/2 cursor-pointer hover:opacity-90 transition-opacity" onClick={scrollToPurchase} role="button" tabIndex={0} aria-label={`Ver ${bonus.subtitle}`} onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') scrollToPurchase();
          }} data-id="element-36">
                <div className="w-full max-w-[420px] mx-auto overflow-hidden rounded-xl shadow-lg shadow-amber-900/20 bg-[#1a1a1a]" data-id="element-37">
                  <img src={bonus.image} alt={bonus.subtitle} loading="lazy" decoding="async" width={420} height={560} className="w-full h-auto object-contain" data-id="element-38" />
                </div>
              </div>

              <div className="w-full md:w-1/2 text-center md:text-left space-y-4" data-id="element-39">
                <span className="inline-block bg-[#1a1a1a] text-amber-500 font-bold px-4 py-1 rounded-full text-sm mb-2 border border-amber-700/40" data-id="element-40">
                  Incluido en el Mega Pack
                </span>
                <h3 className="text-2xl font-bold text-amber-500 uppercase tracking-widest" data-id="element-41">
                  {bonus.title}
                </h3>
                <h4 className="text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-42">
                  {bonus.subtitle}
                </h4>
                <p className="text-lg text-gray-400" data-id="element-43">{bonus.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-44">
          <p className="text-xl font-bold text-white bg-amber-900/30 inline-block px-8 py-4 rounded-lg border border-amber-700/40" data-id="element-45">
            Los 3 bonos se entregan junto con tu acceso al Mega Pack.
          </p>
        </div>
      </div>
    </section>;
}